//@flow
import React from 'react';
import { isEmpty } from 'lodash';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import { Image } from 'components/atoms/image';
import { ArchitectProjectOverlayDescription } from 'components/molecules/architectOverlayDescription';
import Awards from 'components/templates/awards';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {};

export const ArchitectProjectOverlayMobile = (props: Props) => {
  const overlayData = props.data[0];
  const { awardData } = props;
  const {
    bannerImages,
    projectPlanImages,
    galleryImages,
    title,
    location,
  } = overlayData;

  const renderImageContent = (image_path, image_container_className) => {
    return (
      <div className={image_container_className}>
        <Image src={image_path} alt="img" isHoveredImagePresent={true} />
      </div>
    );
  };

  const renderImageSection = ImagesData => {
    if (ImagesData.length > 1) {
      return (
        <div className={'image-container-carousel no-left-padding'}>
          <HorizontalCarousel
            data={ImagesData}
            type={'our-difference-overlay-image'}
            sectionType={'architect-project-overlay'}
          />
        </div>
      );
    } else {
      return renderImageContent(ImagesData[0].mobile_image, 'banner-image');
    }
  };

  const renderAwards = awardData => (
    <div className={'overlay-award-section no-left-padding'}>
      <Awards data={awardData} sectionHeading={`AWARDS BY ${title}`} />
    </div>
  );

  return (
    <div className={'architect-overlay-mobile'}>
      <div className={'inner-container left-padding'}>
        <h1 className={'project-title'}>{title}</h1>
        <h3 className={'project-location'}>{location}</h3>
        {!isEmpty(bannerImages) && renderImageSection(bannerImages)}
        <ArchitectProjectOverlayDescription
          descriptionOne={overlayData.descriptionOne}
          descriptionTwo={overlayData.descriptionTwo}
          projectRichTextOne={overlayData.projectRichTextOne}
          projectRichTextTwo={overlayData.projectRichTextTwo}
          showCtaButton={false}
          onClickCTA={({} = {})}
          className={'project-details-button'}
        />
        {!isEmpty(projectPlanImages) && renderImageSection(projectPlanImages)}
        {!isEmpty(awardData) && renderAwards(awardData)}
        {!isEmpty(galleryImages) && renderImageSection(galleryImages)}
      </div>
    </div>
  );
};
